import { SpaceBetween } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { useEffect, useRef, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;
////import { useStoreAdmin } from '../../../context/useStoreAdmin';
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';


import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import React from 'react';
import BookingGenerate, { BookingGenerateHandles } from '../../../../../components/generates/BookingGenerate';
import { ItemBooking } from '../../../../../resources/types';
dayjs.extend(isBetween);


const pageSize = 20;
interface HourOption {
    value: string;
    label: string;
}
export const MembersBookingsBookPage = () => {


    const { menu, idUser } = useGlobalState();
    const [callBack, setCallBack] = useState('');

    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const hashCallBack = params.get("callBack");
            if (hashCallBack) {
                setCallBack(hashCallBack);
            }
        };
        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);
    const handleBook = async (booking: ItemBooking) => {
        setLoading(true);
        if (booking && booking?.dateStart && booking.dateStart !== ""
            && booking?.dateEnd && booking.dateEnd !== ""
            && booking?.timeStart && booking.timeStart !== ""
            && booking?.timeEnd && booking.timeEnd !== ""
            && booking?.idEquipment > 0 && booking.idUserPilot > 0
        ) {
            try {
                const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/user/bookings/add',
                        'JWT': getCookie("JWT"),

                    },
                    body: JSON.stringify({
                        commit: true,
                        startDate: booking.dateStart + " " + booking.timeStart + ":00",
                        endDate: booking.dateEnd + " " + booking.timeEnd + ":00",
                        idEquipment: booking.idEquipment,
                        idUserPilot: booking.idUserPilot,
                        idUserInstructor: booking.idUserInstructor,
                        idBookingType: booking.idBookingType,
                        idUser: booking.idUserPilot,
                        idInstructor: booking.idUserInstructor,
                        obsBooking: booking.obsBooking,
                        obs: booking.obsBooking,
                        towType: booking.towType,
                        pax: booking.pax,
                        idRequest: booking.idRequest ?? 0,
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const dataWeb = await response.json();
                addNotificationStatus(dataWeb, setData);
                if (dataWeb.code === 0) {
                    if (callBack !== "") {
                        window.location.href = callBack;
                    } else {
                        clearBooking()
                    }
                }

            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }
        }

    };

    const bookingRef = useRef<BookingGenerateHandles>(null);
    const clearBooking = () => {
        //console.log("bookingRef.current", bookingRef.current)
        if (bookingRef.current) {
            bookingRef.current.clearBooking();
        }
    };
    return (
        <CustomAppLayout
            toolsHide={true}


            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="xs">

                    <BookingGenerate
                        ref={bookingRef}
                        idUser={idUser}
                        onChange={(booking) => {
                            //console.log(booking)
                            handleBook(booking)
                        }}
                    />



                </SpaceBetween >
            }
        />

    );
};